import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

/**
 * Recommendation result for a single subject in Chancenkurve
 */
@Entity()
export class ChancenkurveSubjectRecommendation extends AdornisEntity {
  static override _class = 'ChancenkurveSubjectRecommendation';

  @Field(() => String)
  subject: Maybe<string>;

  @Field(() => String)
  status: Maybe<'recommended' | 'completed' | 'override'>;

  @Field(() => String)
  level: Maybe<string>;

  @Field(() => String)
  lessonID: Maybe<string>;

  @Field(() => String)
  reason: Maybe<string>;
}
